// Marker types used for events and tooltip display.
export const UNRECOGNIZED_USER = 1;
export const RECOGNIZED_USER_INSUFFICIENT_DATA = 2;
export const RECOGNIZED_USER_SUFFICIENT_DATA = 3;
